import { Modal, Button, Form } from "react-bootstrap"
import { useEffect, useState } from "react"
import { css } from "@emotion/react"
import { useDispatch, useSelector } from "react-redux"

import { getAgencies, getAgencyList, getContactsByAgency } from "../../../../data/agencySlice"
import Loader from "../../../../components/Loader"
import { sortAgenciesByName } from "../../../../constant/utils"

import { reassignApplicationToUser } from "../../../../data/applicationSlice"
const componentStyle = css`
    .contact {
        margin-top: 12px !important;
    }

    label {
        font-size: 12px !important;
        margin-bottom: 2px;
    }
`

export default function BORModal({ show, setShow, applicationId }) {
    const { agencyList, fetchStatus } = useSelector((state) => state.agency)
    const { fetchStatus: applicationFetchStatus } = useSelector((state) => state.application)
    const [selectedContacts, setSelectedContacts] = useState([])
    const [contactId, setContactId] = useState(null)
    const [agencies, setAgencies] = useState([])
    const dispatch = useDispatch()
    useEffect(() => {
        !agencyList.length && dispatch(getAgencyList())
    }, [])

    function transfer() {
        let payload = {
            id: applicationId,
            userId: contactId
        }
        dispatch(reassignApplicationToUser(payload)).then(() => {
            setShow(false)
        })
    }

    function getContacts(id) {
        dispatch(getContactsByAgency(id)).then(({ payload }) => {
            setSelectedContacts(payload?.items || [])
        })
    }

    useEffect(() => {
        setAgencies(sortAgenciesByName(agencyList))
    }, [agencyList])

    return (
        <Modal
            show={show}
            onHide={() => setShow(false)}>
            <Modal.Header closeButton>
                <Modal.Title>BOR Transfer</Modal.Title>
            </Modal.Header>
            <Modal.Body>
                <div>
                    <Loader show={fetchStatus === "loading" || applicationFetchStatus === "loading"} />
                    {
                        <div>
                            <Form.Group controlId="exampleForm.ControlSelect1">
                                <Form.Label>Agency</Form.Label>
                                <Form.Select
                                    as="select"
                                    onChange={(event) => {
                                        getContacts(event.target.value)
                                    }}>
                                    <option
                                        value={""}
                                        disabled
                                        selected>
                                        ---Select Agency---
                                    </option>
                                    {agencies.map((agency, index) => {
                                        return (
                                            <option
                                                key={index}
                                                value={agency.id}>
                                                {agency.name}
                                            </option>
                                        )
                                    })}
                                </Form.Select>
                            </Form.Group>
                            <Form.Group controlId="exampleForm.ControlSelect1">
                                <Form.Label>Contact</Form.Label>
                                <Form.Control
                                    as="select"
                                    onChange={(e) => {
                                        setContactId(e.target.value)
                                    }}>
                                    <option
                                        value={""}
                                        disabled
                                        selected>
                                        ---Select Contact---
                                    </option>
                                    {selectedContacts?.map((contact, index) => {
                                        return (
                                            <option
                                                key={index}
                                                value={contact.id}>
                                                {contact.firstName + " " + contact.lastName}
                                            </option>
                                        )
                                    })}
                                </Form.Control>
                            </Form.Group>
                        </div>
                    }
                </div>
            </Modal.Body>
            <Modal.Footer>
                <Button
                    size="sm"
                    variant="secondary"
                    onClick={() => setShow(false)}>
                    Cancel
                </Button>
                <Button
                    size="sm"
                    variant="primary"
                    disabled={!contactId}
                    onClick={() => transfer()}>
                    Transfer
                </Button>
            </Modal.Footer>
        </Modal>
    )
}
